import { GuestsObject } from "data/interfaces";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { setGuests as setGuestsSearch } from "application/features/search/searchSlice";
import { useEffect } from "react";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectGuests, selectGuestsCount, setGuestsAdults, setGuestsChildren, setGuestsInfants } from "application/features/guests/guestsSlice";
import Checkbox from "shared/Checkbox/Checkbox";
import { useTranslation } from "react-i18next";


export interface GuestsInputProps {
  onChange?: (data: GuestsObject) => void;
  className?: string;
}


const GuestsInput: FC<GuestsInputProps> = ({
  onChange,
  className = "",
}) => {

  const { t, ready } = useTranslation("translation");
  const guests: GuestsObject = useSelector(selectGuests);
  const total: number = useSelector(selectGuestsCount);
  const dispatch = useDispatch();

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    if (type === "adults") {
      dispatch(setGuestsAdults(value));
    }
    if (type === "children") {
      dispatch(setGuestsChildren(value));
    }
    if (type === "infants") {
      dispatch(setGuestsInfants(value));
    }
    onChange && onChange(guests);
  };


  useEffect(() => {
    dispatch(setGuestsSearch(total))
  }, [guests])


  if (!ready) return null;

  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
        {t("translation:search.common.guests") /* "Guests" */}
      </span>
      <NcInputNumber
        className="w-full"
        defaultValue={guests.adults}
        onChange={(value) => handleChangeData(value, "adults")}
        max={20}
        label={t("translation:search.common.adults") /* "Adults" */}
        desc={t("translation:search.common.adultsDesc") /* "13 years and older" */}
      />
      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guests.children}
        onChange={(value) => handleChangeData(value, "children")}
        max={20}
        label={t("translation:search.common.children") /* "Children" */}
        desc={t("translation:search.common.childrenDesc") /* "2 to 12 years" */}
      />

      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guests.infants}
        onChange={(value) => handleChangeData(value, "infants")}
        max={20}
        label={t("translation:search.common.infants") /* "Infants" */}
        desc={t("translation:search.common.infantsDesc") /* "0 to 2 years" */}
      />
      <Checkbox
        className="mt-6"
        name="company"
        label={t("translation:search.common.business") /* "Viaggia per lavoro?" */}
        subLabel=""
        onChange={(e) => { }}
      />
    </div>
  );
};

export default GuestsInput;
